import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../api-client.config';
import { apiEndpoints } from '../endpoints';
import { queryKeys } from '../react-query.config';
import { toast } from 'sonner';

interface CompletePickemParams {
  pickemId: string;
}

export async function completePickem({ pickemId }: CompletePickemParams) {
  const response = await api.post(apiEndpoints.completePickem(pickemId), {
    confirmScoring: true,
  });
  return response.data;
}

export function useCompletePickemMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: completePickem,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.pickems.all });
      queryClient.invalidateQueries({ queryKey: queryKeys.questions.all });
      toast.success('Pickem completed and scoring initiated');

      // Reload the page after a short delay to show the toast
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    },
    onError: (error: any) => {
      const errorData = error?.response?.data;
      let errorMessage = errorData?.error || 'Failed to complete pickem';

      // If there are questions without results, show them in the error
      if (
        errorData?.questions_without_results &&
        Array.isArray(errorData.questions_without_results)
      ) {
        const questionList = errorData.questions_without_results
          .map((q: any) => `"${q.text}" (${q.type})`)
          .join(', ');
        errorMessage = `${errorMessage}: ${questionList}`;
      }

      // Show additional context if available
      if (errorData?.current_status) {
        errorMessage = `${errorMessage} (Current status: ${errorData.current_status})`;
      }

      toast.error(errorMessage);
    },
  });
}
